import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Bid_Authorization.css';

const PREAUCT_Bid_Authorization = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_BID_AUTHORIZATION",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_BID_AUTHORIZATION:-1
  });


  const [PREAUCT_BID_AUTHORIZATION, setPREAUCT_BID_AUTHORIZATION] = React.useState(null);
  const [PREAUCT_BID_AUTHORIZATION_D, setPREAUCT_BID_AUTHORIZATION_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Bid Authorization');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_BID_AUTHORIZATION(clientInfo,"OpenNew");

		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_BID_AUTHORIZATION(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_BID_AUTHORIZATION(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_BID_AUTHORIZATION(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_BID_AUTHORIZATION(Temp_Data2);
			navigate('/PREAUCT_Bid_Authorization#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Bid_Authorization',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_BID_AUTHORIZATION) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_BID_AUTHORIZATION]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_BID_AUTHORIZATION){
	  for(var Sec in PREAUCT_BID_AUTHORIZATION[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_BID_AUTHORIZATION[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_BID_AUTHORIZATION[Ele]["status"]);
		else if(Array.isArray(PREAUCT_BID_AUTHORIZATION[Ele][Sec]))
			  for(var Row in PREAUCT_BID_AUTHORIZATION[Ele][Sec])  // Convert to PREAUCT_BID_AUTHORIZATION[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_BID_AUTHORIZATION[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_BID_AUTHORIZATION"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_BID_AUTHORIZATION(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION`).then((response1) => {
		if(!PREAUCT_BID_AUTHORIZATION) 
			setPREAUCT_BID_AUTHORIZATION(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION_D`).then((response2) => {
			setPREAUCT_BID_AUTHORIZATION_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_BID_AUTHORIZATION_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_BID_AUTHORIZATION = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_BID_AUTHORIZATION(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_BID_AUTHORIZATION = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_BID_AUTHORIZATION = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_BID_AUTHORIZATION = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_BID_AUTHORIZATION = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_BID_AUTHORIZATION', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["1"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["1"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["1"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["2"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["2"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["2"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["2"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  


    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["2"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["3"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["4"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
  }; 
  

    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
  }; 
  

    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["5"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["9"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
  }; 
  

    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["9"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["9"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["9"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
	Temp_Data["9"]["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4"]=value;
	//handleAddPREAUCT_BID_AUTHORIZATION(Temp_Data,App_Data['PREAUCT_BID_AUTHORIZATION']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_BID_AUTHORIZATION(Temp_Data);
    setPREAUCT_BID_AUTHORIZATION(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_BID_AUTHORIZATION) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_BID_AUTHORIZATION =JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
  updatedPREAUCT_BID_AUTHORIZATION[Sec] = [...updatedPREAUCT_BID_AUTHORIZATION[Sec], newRow];
  setPREAUCT_BID_AUTHORIZATION(updatedPREAUCT_BID_AUTHORIZATION);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_BID_AUTHORIZATION = JSON.parse(JSON.stringify(PREAUCT_BID_AUTHORIZATION));
  updatedPREAUCT_BID_AUTHORIZATION[sec].splice(index, 1);
  setPREAUCT_BID_AUTHORIZATION(updatedPREAUCT_BID_AUTHORIZATION);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Bid Authorization`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Bid Authorization ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Bid Authorization ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0" type="text" className="form-control" placeholder="PREAUCT Bid Authorization ID" value={PREAUCT_BID_AUTHORIZATION["1"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Bid Authorization ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID" value={PREAUCT_BID_AUTHORIZATION["1"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pre Auction Pool ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2" type="text" className="form-control" placeholder="PREAUCT Pre Auction Pool ID" value={PREAUCT_BID_AUTHORIZATION["1"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pre Auction Pool ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Authorized Max Bid USD`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Authorized Max Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0" type="text" className="form-control" placeholder="Authorized Max Bid USD" value={PREAUCT_BID_AUTHORIZATION["2"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Authorized Max Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bidder Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1" type="text" className="form-control" placeholder="Bidder Name" value={PREAUCT_BID_AUTHORIZATION["2"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Bidder Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bidder Entity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2" type="text" className="form-control" placeholder="Bidder Entity ID" value={PREAUCT_BID_AUTHORIZATION["2"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Bidder Entity ID`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Bid Deposit Confirmed`)} <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3_Change} 
					  checked={PREAUCT_BID_AUTHORIZATION?.["2"]?.["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3"] === "true" || PREAUCT_BID_AUTHORIZATION?.["2"]?.["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_3"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bid Deposit Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4" type="text" className="form-control" placeholder="Bid Deposit Amount USD" value={PREAUCT_BID_AUTHORIZATION["2"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Bid Deposit Amount USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Authorization Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Authorization Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0" type="text" className="form-control" placeholder="Authorization Document Link" value={PREAUCT_BID_AUTHORIZATION["3"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Authorization Document Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Bid Authorization Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Bid Authorization Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0"  value={PREAUCT_BID_AUTHORIZATION["4"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0`]} onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_4_0_Change} className="form-control" name="Bid Authorization Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Expired">Expired</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Bid Authorization Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0" type="text" className="form-control" placeholder="Submitted By" value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1" type="text" className="form-control" placeholder="Submitted At" value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2" type="text" className="form-control" placeholder="Reviewed By" value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3" type="text" className="form-control" placeholder="Reviewed At" value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4"  value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4`]} onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5" type="text" className="form-control" placeholder="Approval Notes" value={PREAUCT_BID_AUTHORIZATION["5"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0"  value={PREAUCT_BID_AUTHORIZATION["9"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0`]} onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_BID_AUTHORIZATION["9"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_BID_AUTHORIZATION["9"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_BID_AUTHORIZATION["9"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_BID_AUTHORIZATION["9"][`PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4`]} 
						onChange={PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_05_BID_AUTHORIZATION_SUBMISSION_RESULT_PREAUCT_BID_AUTHORIZATION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Bid_Authorization;  